var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "fixBottom", staticClass: "popup px-16 py-24 p-md-24 p-lg-56" },
    [
      _c("div", {
        staticClass: "close",
        on: {
          click: function($event) {
            return _vm.$emit("close")
          }
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "add-gift" }, [
        _c("h2", { staticClass: "mb-32" }, [
          _vm._v(_vm._s(_vm.translations.add_gift_popup.title))
        ]),
        _vm._v(" "),
        _c("p", {
          staticClass: "mb-24",
          domProps: {
            innerHTML: _vm._s(_vm.translations.add_gift_popup.description)
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row mb-n32" },
          _vm._l(_vm.itemsWithoutAlreadySelectedGifts, function(gift) {
            return _c("div", { key: gift.id, staticClass: "col-6" }, [
              _c(
                "div",
                {
                  staticClass: "gift mb-32",
                  on: {
                    click: function($event) {
                      return _vm.addGift(gift)
                    }
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "ar mb-8",
                      style: {
                        "padding-top": (_vm.arHeight / _vm.arWidth) * 100 + "%"
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: gift.acf.image.sizes.medium_large,
                          alt: gift.post_name
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("p", {
                    staticClass: "title",
                    domProps: { innerHTML: _vm._s(gift.post_title) }
                  })
                ]
              )
            ])
          }),
          0
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }